export const touch = (
  targetElement,
  { onTouchStart, onTouchMove, onTouchCancel, onTouchEnd }
) => {
  let start = {};
  let end = {};

  const handleTouchStart = e => {
    document.ontouchmove = e => e.preventDefault();
    start = Object.assign({}, start, {
      x: e.touches[0].clientX,
    });
    end = start;
    onTouchStart && onTouchStart(start, end);
  };

  const handleTouchMove = e => {
    end = Object.assign({}, start, {
      x: e.touches[0].clientX,
    });
    onTouchMove && onTouchMove(start, end);
  };

  const handleTouchCancel = () => {
    onTouchCancel && onTouchCancel(start, end);
  };

  const handleTouchEnd = () => {
    document.ontouchmove = () => true;
    onTouchEnd && onTouchEnd(start, end);
  };

  targetElement.addEventListener('touchstart', handleTouchStart);
  targetElement.addEventListener('touchmove', handleTouchMove);
  targetElement.addEventListener('touchcancel', handleTouchCancel);
  targetElement.addEventListener('touchend', handleTouchEnd);

  return {
    destroy() {
      targetElement.removeEventListener('touchstart', handleTouchStart);
      targetElement.removeEventListener('touchmove', handleTouchMove);
      targetElement.removeEventListener('touchcancel', handleTouchCancel);
      targetElement.removeEventListener('touchend', handleTouchEnd);
    },
  };
};
